import React from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { TableColumn } from '../../agent-performance/tableConfig';
import { AgentMetricsData } from '../../agent-performance/agentTableTypes';
import { convertLocalTimezone } from '@/utils/dateUtils';
import z from 'zod';

type CellValue = string | number | boolean | undefined;

interface AgentMetricsTableCellProps {
  column: TableColumn;
  value: CellValue;
  rowData: AgentMetricsData;
  isExpanded?: boolean;
  isLoading?: boolean;
}

export const AgentMetricsTableCell: React.FC<AgentMetricsTableCellProps> = ({ 
  column, 
  value, 
}) => {
  const renderCellContent = () => {
    switch (column.key) {
      case "displayName":
        return <span className="font-medium">{value}</span>;
    }
  };

  const renderTooltipContent = () => {
    switch (column.key) {
      case "displayName":
        return `Agent: ${value}`;
    }
  };

  return (
    <div className="td-cell flex-1 min-w-0">
      <TooltipProvider>
        <Tooltip delayDuration={0}>
          <TooltipTrigger asChild>
            <p className="truncate text-left px-2 d-inline-block w-full overflow-hidden">
              {renderCellContent()}
            </p>
          </TooltipTrigger>
          <TooltipContent side="top" align="start" className="z-50">
            <p className="max-w-xs text-xs">
              {renderTooltipContent()}
            </p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};